import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
  useLocation
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import Insights from "../../pages/insights";
import Refunds from "../../pages/refunds";
import Customers from "../../pages/customers";
import EditCustomer from '../../pages/customers/EditCustomer';
import Jobs from "../../pages/jobs";
import ClosedJobs from "../../pages/jobs/ClosedJobs";
import AddJob from "../../pages/jobs/AddJob";
import EditJob from '../../pages/jobs/EditJob';
import Retests from "../../pages/retests/Retests";
import BookJob from "../../pages/retests/BookJob";
import RetestEmail from "../../pages/retests/RetestEmail";
import Assets from "../../pages/assets";
import EditSite from '../../pages/sites/EditSite';
import EditAsset from '../../pages/assets/EditAsset';
import Typography from "../../pages/typography";
import Notifications from "../../pages/notifications";
import Maps from "../../pages/maps";
import Tables from "../../pages/tables";
import Icons from "../../pages/icons";
import Charts from "../../pages/charts";
import ViewInvoicingSummary from "../../pages/invoice/ViewInvoicingSummary";
import Workers from "../../pages/workers";
import Accounts from "../../pages/accounts";
import EditAccount from '../../pages/accounts/EditAccount';
import Reports from '../../pages/reports';
import Upload from '../../pages/upload';
import UploadCustomTests from '../../pages/upload_custom_tests';
import CPI from '../../pages/cpi/CPI';
import GlobalSearch from "../../pages/globalSearch";

// context
import { useLayoutState } from "../../context/LayoutContext";

function Layout(props) {
  var classes = useStyles();
  const location = useLocation();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classnames({
          [classes.root]: location.pathname.indexOf('/invoice/summary/') === -1,
          [classes.rootWithOverflow]: location.pathname.indexOf('/invoice/summary/') > 0
        })}>
        <>
          {location.pathname.indexOf('/invoice/summary/') === -1 ? <Header history={props.history} /> : null}
          {location.pathname.indexOf('/invoice/summary/') === -1 ? <Sidebar /> : null}
          {/*}<Header history={props.history} />
          <Sidebar />*/}
          <div
            className={classnames({
              [classes.content]: location.pathname.indexOf('/invoice/summary/') === -1,
              [classes.contentFull]: location.pathname.indexOf('/invoice/summary/') > 0,
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            {location.pathname.indexOf('/invoice/summary/') === -1 ? <div className={classes.fakeToolbar} /> : null}
            {/*<div className={classes.fakeToolbar} />*/}
            <Switch>
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/search" component={GlobalSearch} />
              <Route path="/app/insights" component={Insights} />
              <Route path="/app/refunds" component={Refunds} />
              <Route path="/app/customers" component={Customers} />
              <Route path="/app/customer/edit/:id" component={EditCustomer} />
              <Route path="/app/jobs" component={Jobs} />
              <Route path="/app/closed" component={ClosedJobs} />
              <Route path="/app/job/add" component={AddJob} />
              <Route path="/app/job/edit/:id" component={EditJob} />
              {/*<Route path="/app/job/:id/edit" component={JobEdit} />
              <Route path="/app/job/:id" component={JobEdit} />*/}
              <Route path="/app/retests" component={Retests} />
              <Route path="/app/retest-emails" component={RetestEmail} />
              <Route path="/app/retest/book/:id" component={BookJob} />
              <Route path="/app/assets" component={Assets} />
              <Route path="/app/asset/edit/:id" component={EditAsset} />
              <Route path="/app/site/edit/:id" component={EditSite} />
              <Route path="/app/site/retest/book/:id" component={BookJob} />
              <Route path="/app/invoice/summary/:id" component={ViewInvoicingSummary} />
              <Route path="/app/workers" component={Workers} />
              <Route path="/app/accounts" component={Accounts} />
              <Route path="/app/account/edit/:id" component={EditAccount} />
              <Route path="/app/account/add" component={EditAccount} />
              <Route path="/app/reports" component={Reports} />
              <Route path="/app/upload" component={Upload} />
              <Route path="/app/metrel_upload_custom_tests" component={UploadCustomTests} />
              <Route path="/app/cpi" component={CPI} />

              <Route path="/app/typography" component={Typography} />
              <Route path="/app/tables" component={Tables} />
              <Route path="/app/notifications" component={Notifications} />
              <Route
                exact
                path="/app/ui"
                render={() => <Redirect to="/app/ui/icons" />}
              />
              <Route path="/app/ui/maps" component={Maps} />
              <Route path="/app/ui/icons" component={Icons} />
              <Route path="/app/ui/charts" component={Charts} />
            </Switch>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
